import { render } from "./editProductOffer.vue?vue&type=template&id=4248affa&scoped=true"
import script from "./editProductOffer.vue?vue&type=script&lang=js"
export * from "./editProductOffer.vue?vue&type=script&lang=js"

import "./editProductOffer.vue?vue&type=style&index=0&id=4248affa&scoped=true&lang=less"

import exportComponent from "D:\\wkb\\dev\\study\\盘雷\\lida-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4248affa"]])

export default __exports__